<template>
  <div>
    <van-popup v-model:show="isShow" round position="bottom" safe-area-inset-bottom>
      <div>
        <van-picker
          class="seriesModels"
          :class="{ planSeriesModels: ['oab', 'plan'].includes(from) }"
          title="车系车型"
          :ref="refCar"
          :visible-item-count="9"
          :columns="seriesModels"
          @confirm="onConfirmCarType"
          @cancel="isShow = false"
        />
      </div>
    </van-popup>
  </div>
</template>

<script>
import { reactive, toRefs, watch, nextTick, onMounted } from 'vue'
import { getSeriesModels } from '@/api/plan'
import { useStore } from 'vuex'
import { setSession, getSession } from '@/util'
import { onBeforeRouteLeave } from 'vue-router'
export default {
  props: ['datas', 'showPopUp', 'currentCar', 'from', 'initCarText'],
  setup(props, { emit }) {
    const store = useStore()
    let { datas, showPopUp, currentCar, initCarText } = toRefs(props)
    const state = reactive({
      isShow: false,
      datas,
      showPopUp,
      currentCar,
      seriesModels: [],
      initCarText
    })
    onBeforeRouteLeave(() => {
      state.isShow = false
    })
    let elm = ''
    const refCar = el => {
      elm = el
    }
    watch(
      () => state.showPopUp,
      async n => {
        state.isShow = true
        let {
          currentCarClassInfo: { iArr = null, baumuster = '', series = '' }
        } = store.state
        if (state.datas && state.datas.length) {
          state.seriesModels = state.datas
          if (state.currentCar && state.currentCar.modelList && n >= 1) {
            let { seriesIndex, modelList, modelIndex } = state.currentCar
            nextTick(() => {
              elm.setColumnValues(1, modelList)
              elm.setIndexes([seriesIndex, modelIndex])
            })
          }
        } else {
          console.log('xxxxxxxxxx')
          let planModels = getSession('planModels')
          if (!planModels.length) {
            planModels = await getSeriesModels()
            setSession('planModels', planModels)
          }
          state.seriesModels = planModels
          if (!iArr) {
            iArr = baumuster ? getIndexArr(planModels, baumuster, series) : [0, 0]
          }
          nextTick(() => {
            elm.setColumnValues(1, planModels[iArr[0]]['children'])
            elm.setIndexes(iArr)
          })
        }
      }
    )
    watch(
      () => state.initCarText,
      () => {
        getInitCarText()
      }
    )

    const getInitCarText = async () => {
      let {
        currentCarClassInfo: { baumuster = '', series = '' }
      } = store.state
      if (baumuster === '') {
        return
      }
      let planModels = getSession('planModels')
      if (!planModels.length) {
        planModels = await getSeriesModels()
        setSession('planModels', planModels)
      }
      const iArr = getIndexArr(planModels, baumuster, series)
      const matchedCar = planModels[iArr[0]].children[iArr[1]]

      emit('selectCarResult', matchedCar)
    }
    // 初始化定位
    const getIndexArr = (data, key, series) => {
      let iArr = [0, 0]
      let seriesIndex = 0
      let tempData = []
      if (data && data.length) {
        if (series === 'baumusterOnly') {
          const seriesData = data.find(d => d.children.find(car => car.baumuster === key))
          series = seriesData.text
        }

        for (let i = 0; i < data.length; i++) {
          if (data[i].text === series) {
            tempData = data[i]['children']
            seriesIndex = i
            break
          }
        }
        // console.log(key, series, tempData);
        for (let i = 0; i < tempData.length; i++) {
          if (tempData[i] && tempData[i]['baumuster'] && tempData[i]['baumuster'] === key) {
            iArr = [seriesIndex, i]
            break
          }
        }
      }
      return iArr
    }
    const onConfirmCarType = val => {
      state.isShow = false
      let iArr = elm.getIndexes(val)
      let car = state.seriesModels[iArr[0]].children[iArr[1]]
      let currentCarClassInfo = { ...car, iArr, series: val[0].text }
      store.dispatch('setCurrentCarClassInfo', currentCarClassInfo)
      emit('selectCarResult', currentCarClassInfo)
    }
    onMounted(async () => {})
    return {
      ...toRefs(state),
      onConfirmCarType,
      refCar
    }
  }
}
</script>

<style lang="scss" scoped>
.box {
  padding: 15px 20px;
}
.title {
  font-size: 15px;
  font-weight: bold;
  color: #333333;
}
.content {
  font-size: 12px;
  color: #666666;
  line-height: 2;
  margin-top: 20px;
}
button {
  margin-top: 28px;
}
.seriesModels {
  :deep(.van-picker-column:nth-child(2)) {
    width: 30%;
    flex-basis: 20%;
  }
}
.planSeriesModels {
  :deep(.van-picker-column:nth-child(1)) {
    li {
      justify-content: flex-start;
      padding-left: 16px;
      box-sizing: border-box;
    }
  }
  :deep(.van-picker-column:nth-child(2)) {
    width: 40%;
    flex-basis: 40%;
    li {
      justify-content: flex-start;
    }
  }
}
</style>
